import type { FC } from 'react'
import styled from 'styled-components'

import SmallPill from '@/components/SmallPill'
import type { CompanyCCJ } from '@/types/Activity'

import OrganisationCCJFields from './OrganisationCCJFields'

const Container = styled.div`
  display: grid;
  gap: 10px;
`

const CCJCreditContainer = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
`

export type Fields = CompanyCCJ[]

interface Props {
  values: Fields
  onChangeValues: (fields: Fields) => void
  onAdd: () => void
}

const OrganisationCCJsFields: FC<Props> = ({ values, onChangeValues, onAdd }) => (
  <Container>
    <div>
      {values.length === 0 ? (
        <p>No adverse credit.</p>
      ) : (
        values.map((adverseCredit, i) => (
          <CCJCreditContainer key={i}>
            <OrganisationCCJFields
              key={i}
              itemNumber={i + 1}
              values={adverseCredit}
              onChangeValues={newCCJFields =>
                onChangeValues(values.map((a, k) => (k === i ? newCCJFields : a)))
              }
              onRemove={() => onChangeValues(values.filter((_, k) => i !== k))}
            />
          </CCJCreditContainer>
        ))
      )}
    </div>
    <SmallPill onClick={onAdd}>Add another</SmallPill>
  </Container>
)

export default OrganisationCCJsFields
